var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAltaTecnologia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3213 0H2.79856C1.25352 0 0 1.0498 0 2.34375V22.6562C0 23.9502 1.25352 25 2.79856 25H23.3213C24.8663 25 26.1199 23.9502 26.1199 22.6562V2.34375C26.1199 1.0498 24.8663 0 23.3213 0ZM13.0599 23.4375C12.028 23.4375 11.1942 22.7393 11.1942 21.875C11.1942 21.0107 12.028 20.3125 13.0599 20.3125C14.0919 20.3125 14.9256 21.0107 14.9256 21.875C14.9256 22.7393 14.0919 23.4375 13.0599 23.4375ZM23.3213 18.1641C23.3213 18.4863 23.0065 18.75 22.6217 18.75H3.4982C3.11339 18.75 2.79856 18.4863 2.79856 18.1641V2.92969C2.79856 2.60742 3.11339 2.34375 3.4982 2.34375H22.6217C23.0065 2.34375 23.3213 2.60742 23.3213 2.92969V18.1641Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltaTecnologia);
export default __webpack_public_path__ + "static/media/alta-tecnologia.e7ca94d2ab2765551084a163b5aaadcf.svg";
export { ForwardRef as ReactComponent };